const PFLEGE_STATUS: Record<string, string> = {
  entwurf: "Entwurf", angeboten: "Angebot beim Kunden", zugestimmt: "Zugestimmt, noch nicht aktiviert",
  aktiv: "läuft", pausiert: "pausiert", gekuendigt: "gekündigt",
};

/**
 * Pflegevertrag in der Kundenakte (09.10.2026): bis dahin stand hier immer
 * „Pflegevertrag anbieten", auch wenn längst einer lief. Jetzt der Stand des
 * aktuellen Vertrags mit Weg in die Pflege-App — und das Angebot nur ohne Vertrag.
 */
export default function PflegevertragZeile({ kundeId, vertraege }: { kundeId: string; vertraege?: { id: string; nummer: string; status: string; monats_netto: number | string | null }[] }) {
  const pflege = "https://pflege.vimaanagarten.de";
  const aktuell = (vertraege || []).find((v) => v.status !== "beendet");
  if (!vertraege) return null;
  return (
    <p className="lf-hinweis" style={{ marginTop: 8 }}>
      {aktuell ? (
        <>
          Pflegevertrag {aktuell.status === "entwurf" ? "(Entwurf)" : aktuell.nummer} · {PFLEGE_STATUS[aktuell.status] ?? aktuell.status}
          {aktuell.monats_netto ? ` · ${Number(aktuell.monats_netto).toLocaleString("de-DE", { style: "currency", currency: "EUR" })} im Monat netto` : ""}
          {" "}
          <a href={`${pflege}/kunden?kunde=${encodeURIComponent(kundeId)}`} target="_blank" rel="noreferrer">in der Pflege öffnen ›</a>
        </>
      ) : (
        <a href={`${pflege}/vertraege/neu?kunde=${encodeURIComponent(kundeId)}`} target="_blank" rel="noreferrer">
          {vertraege.length ? "Neuen Pflegevertrag anbieten ›" : "Pflegevertrag anbieten ›"}
        </a>
      )}
    </p>
  );
}
